import { Component } from '@angular/core';


@Component({
  selector: 'sp-footer,footer[sp-footer]',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
